
import {CheckpointCardView} from "../views/checkpointCardView.jsx"

function CheckpointListItem({
  sortedLocations,
  visitedIds,
  userCheckpointsData,
  onDiscover
}) {
  return (
    <div>
      {sortedLocations.map(([locId, data]) => {
        const isVisited = visitedIds.includes(locId);

        let timeCount = 0;
        let spaceCount = 0;
        let timeProgress = 0;
        let spaceProgress = 0;
        let totalProgress = 0;

         const checkpointData = userCheckpointsData?.[locId] || {};
        if (isVisited) {
          timeCount = Object.keys(checkpointData?.time || {}).length;
          spaceCount = Object.keys(checkpointData?.space || {}).length;
          timeProgress = (timeCount / 4) * 100;
          spaceProgress = (spaceCount / 4) * 100;
          totalProgress = timeCount + spaceCount;
        }

        return (
         <CheckpointCardView
            key={locId}
            locId={locId}
            data={data}
            isVisited={isVisited}
            timeProgress={timeProgress}
            spaceProgress={spaceProgress}
            totalProgress={totalProgress}
            onDiscover={onDiscover}
            infoSignal
          />
        );
      })}
    </div>
  );
}

export { CheckpointListItem };
